import React, { useEffect, useReducer} from 'react';
import {Container, Row,Button, Nav} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"
import Subfooter from './Subfooter';

const Credit = () => {
    useEffect(() =>{
        document.title = "Credit | Rich-Oak Group"
    },[])

    return (
      
      <div>





<div className="homepageslider" id="homepageslider">
<Header/>
{/* <Container className=''> */}


<div  id="creditbox">
    <Row >
    <div className="col-lg-7 col-md-12">
        <div className='hmfirstinnerbox'>
        <h3 className="hmfirstboxheading">Credit</h3>
        <p className='description hmfirstboxdescription'>We are building long-term relationships with our clients, partnering with<br/>
        individuals and institutions to achieve long term financial growth.</p>
        
        <p class="centermobile">
        <a href="#learnmore"><button className='hmfirstboxbutton hmbuttons'>LEARN MORE</button></a>
        {/* <h4 className="hmbuttons hmvot">View our team <img src="images/arrow_forward.png"/></h4> */}
        </p>
        {/* <p class="centermobile">
        <button className='hmfirstboxbutton hmbuttons'>LEARN MORE</button>
        <h4 className="hmbuttons hmvot">View our team <img src="images/arrow_forward.png"/></h4>
        </p> */}

  
        </div>
    </div>
    </Row>
    </div>



    <div className='hmsecondbox'>
 
    </div>


    {/* <div className='hmthirdbox'>
    <div className=''>
            <Row>
                <div className='col-md-6'>
                <img style={{width:"100%"}} src="images/whoweare.png"/> 
                    </div>


                    <div className='col-md-6'>
                    <h1 className="hmwwd"><span style={{color:"#D80032"}}> Our </span>Credit</h1>
                    <p  className="hmwwdp"></p>
               
                    <p className='hmsecondboxdescription'>Rich-Oak Group is a financial institution building reliable financial partnerships with individuals and institutions through professionalism, 
                        innovation and providing premium value. Our vision is to be Africa's most reliable financial partner. 
                        We invest capital on behalf of individuals and institutions across the alternative asset classes in real estate, 
                        credit and agriculture, increasing the wealth of our investors.
                         Our businesses are impact driven, providing support to various industries and sectors.</p>
                    </div>

          
               
                
            </Row>
        </div>
    </div> */}




 <div className='hmfourthbox' id="learnmore">
    <div className=''>

            <Row>
                <div className='col-lg-4 col-md-12'>
        <p className='hmcia fordesktoponly'>Our
       <span style={{color:"#D80032"}} > Credit</span> <br/>
        Solutions
        </p>

        <p className='hmcia formobileonly'>Current
       <span style={{color:"#D80032"}} > Investment</span> <br/>
        Allocation
        </p>
        <p  className="hmwwdp"></p>
        <p className='hmfourthboxinner hmfourthboxinner1 '>
        We have disbursed over N200M in credit since 2016, allowing individuals and businesses expand. We look out for businesses that are innovative and show consistency in their growth and services.
        </p>
        <p className='hmfourthboxinner hmfourthboxinner1 '>
We are expanding and continuously looking for opportunities in the market, insisting that credit can be a necessary good. We support our individual and business partners through our diverse range of credit products, we help them fulfill their goals, meet urgent cash needs, take advantage of opportunities, and enable businesses prosper.
        </p>
                    </div>


                    <div className='col-lg-4 col-md-6'>
                  
                       <img class="img-fluid"  src="images/consumerloan.jpeg"/>
                       <div class="divinvestments ">
                       <p className="hmciahead">Consumer Loans</p>
                        <p  className='hmfourthboxinner'>
                        We offer individuals with consistent high credit scores access to quick and short term duration loans.                            
                            </p>
                           </div>
                    
                    </div>

        

                    <div className='col-lg-4 col-md-6'>
                    <img class="img-fluid" style={{height:"284.77px"}} src="images/visafinancing.png"/>
                    <div class="divinvestments">
                                            <p className="hmciahead">Visa Financing</p>
                        <p  className='hmfourthboxinner'>
                        For individuals seeking immigrations or study visas. We assist them with funds to meet their travel requirements.                            
                            </p>
                    </div>
                    </div>

               
               
                
            </Row>

            <Row className="ciasecondbox">
                <div className='col-lg-4 col-md-0'>

                    </div>


                    <div className='col-lg-4 col-md-6'>
                    <img class="img-fluid" src="images/sme.jpeg"/>
                    <div class="divinvestments">
                                            <p className="hmciahead">SME/Business Funding</p>
                        <p   className='hmfourthboxinner2'>
                        We build strategic partnerships with SME`s, offering them financial support and business advisory services.                            
                            </p>
                    </div>
                    </div>

            

                    {/* <div className='col-lg-4 col-md-6'>
                    <img class="img-fluid" style={{height:"284.77px"}}  src="images/4.jpeg"/>
                    <div class="divinvestments">
                                            <p className="hmciahead">Real estate</p>
                        <p   className='hmfourthboxinner2'>
                            
                          The Local Purchase Order is relevant for contractors and vendors to private and international organizations.

                            
                            </p>
                    </div>
                    </div> */}

               
               
                
            </Row>
   
        </div>
    </div> 



    <Subfooter/>


    </div>

<div id="homepagethirdbox">
    

</div>






    <Footer/>
    </div>


    )
    
    
}


export {Credit as default}